<div class="itsl-course-info-box__content">
    <h2 class="itsl-course-info-box__title">{title}</h2>
    <div
        class="itsl-course-info-box__description"
        class:itsl-course-info-box__description--empty={descriptionIsEmpty}>
        <SimpleRtfEditor
            headingLevel={defaultEditorHeadingLevel}
            i18n={i18n.rtfEditor}
            label={i18n.description}
            labelHidden
            readOnly
            showSkipLink={false}
            bind:this={rtfEditor}
        />
    </div>
    {#if showTeachers}
        <CourseInfoBoxTeachers courseTeachersTitle={i18n.courseTeachers} {teachers} />
    {/if}
    {#if canAdminGeneral}
        <Link kind="secondary-standalone" href={editPageUrl}>{i18n.edit}</Link>
    {/if}
</div>

<script>
    import { onMount } from "svelte";
    import Link from "@itslearning/prometheus/assets/Navigation/Link/v1/Link.svelte";
    import SimpleRtfEditor from "@itslearning/prometheus/assets/nodes/SimpleRtfEditor/v1/SimpleRtfEditor.svelte";
    import CourseInfoBoxTeachers from "./CourseInfoBoxTeachers.svelte";

    import { defaultEditorHeadingLevel } from "../../constants";
    import { isEmptyRtfContent, setRtfContent } from "../../utils";

    export let canAdminGeneral;
    export let description;
    export let editPageUrl;
    export let i18n;
    export let showTeachers;
    export let teachers;
    export let title;

    /** @type {SimpleRtfEditor} */
    let rtfEditor;

    $: descriptionIsEmpty = isEmptyRtfContent(rtfEditor);

    onMount(() => setRtfContent(rtfEditor, description));
</script>
